import { RECEIVE_SIMPLEORDER, REQUEST_SIMPLEORDER, RECEIVE_EXTENSIONS_WHITE_LIST, REQUEST_EXTENSIONS_WHITE_LIST } from '../actions/a.simple-order-form'

import Store from '../store'

const SimpleOrder = (state = Store.SimpleOrder, action) => {
    switch (action.type) {
        case REQUEST_SIMPLEORDER:
            return {
                ...state,
                isFetching: true,
            }
        case RECEIVE_SIMPLEORDER:
            return {
                ...state,
                isFetching: false,
            }
        case REQUEST_EXTENSIONS_WHITE_LIST:
            return {
                ...state,
                isFetching: true,
            }
        case RECEIVE_EXTENSIONS_WHITE_LIST:
            return {
                ...state,
                extenstionsWhitelist: action.payload,
                isFetching: false,
            }
        default:
            return state
    }
}

export default SimpleOrder